var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 144,
    viewBox: "0 0 109 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M18.7721 141V142.5H20.2721H33.3794H34.8794V141V3V1.5H33.3794H23.4571H22.5618L22.1368 2.28804C20.9841 4.42566 19.5689 6.28483 17.8925 7.87453L17.8799 7.88653L17.8675 7.89882C16.2377 9.51793 14.5017 10.8573 12.6602 11.9244L12.6481 11.9314L12.6361 11.9387C10.8146 13.0401 9.00013 13.9721 7.1927 14.7372L7.1815 14.7419L7.17039 14.7468C5.40513 15.528 3.86105 16.1325 2.53348 16.567L1.5 16.9052V17.9926V31.7926V33.2926H3C3.12476 33.2926 3.22865 33.2763 3.25148 33.2727L3.25397 33.2723C3.29492 33.266 3.33267 33.2589 3.36122 33.2532C3.41964 33.2416 3.48573 33.2269 3.55309 33.2113C3.69018 33.1795 3.87506 33.134 4.10272 33.0764C4.56024 32.9608 5.22009 32.7887 6.07907 32.5611C7.78993 32.1079 9.74645 31.5976 11.9489 31.0304C14.1746 30.4571 16.1648 29.881 17.9165 29.3013C18.2248 29.2038 18.5102 29.1123 18.7721 29.0268V141ZM80.0802 141V142.5H81.5802H94.075H95.575V141V105.53H105.222H106.722V104.03V87.8444V86.3444H105.222H95.575V3V1.5H94.075H78.6403H77.5405L77.2097 2.5488L51.3628 84.4969L51.2933 84.7172V84.9481V104.03V105.53H52.7933H80.0802V141ZM80.0802 36.9707V86.3444H67.3465L80.0802 36.9707Z",
    stroke: "#757575",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg14);
export default __webpack_public_path__ + "static/media/14.bb1a4cf84f553f67c90c4aa5f964307c.svg";
export { ForwardRef as ReactComponent };